import { render, staticRenderFns } from "./DeleteShipmentButton.vue?vue&type=template&id=5a5b103f&"
import script from "./DeleteShipmentButton.vue?vue&type=script&lang=js&"
export * from "./DeleteShipmentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5b103f')) {
      api.createRecord('5a5b103f', component.options)
    } else {
      api.reload('5a5b103f', component.options)
    }
    module.hot.accept("./DeleteShipmentButton.vue?vue&type=template&id=5a5b103f&", function () {
      api.rerender('5a5b103f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/buttons/DeleteShipmentButton.vue"
export default component.exports